import React from 'react';
import PropTypes from 'prop-types';
import unescape from 'lodash/unescape';
import Breadcrumbs from 'common/breadcrumbs/Breadcrumbs';

const SpotListBreadcrumbs = ({
    data: {
        city: {relativeUrl, displayName},
        extraBreadcrumb: {url: extraUrl, label: extraLabel},
        activeBreadcrumb: {url, label},
    },
}) => {
    return (
        <Breadcrumbs
            className="SpotListBreadcrumbs"
            items={
                label === 'Current Location'
                    ? [{label: unescape(label), active: true}]
                    : [
                          {
                              label: unescape(displayName),
                              link: relativeUrl,
                          },
                          extraUrl && {
                              label: unescape(extraLabel),
                              link: extraUrl,
                          },
                          {
                              label: unescape(label),
                              link: url,
                              active: true,
                          },
                      ].filter(Boolean)
            }
        />
    );
};

SpotListBreadcrumbs.propTypes = {
    data: PropTypes.object.isRequired,
};

export default SpotListBreadcrumbs;
